'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PRIVATE_SETTING_ERROR_HANDLED = exports.USER_SETTING_GET_FAILURE = exports.USER_SETTING_GET_COMPLETE = exports.USER_SETTING_GET_START = exports.USER_SETTING_SET_FAILURE = exports.USER_SETTING_SET_COMPLETE = exports.USER_SETTING_SET_START = undefined;
exports.setUserSettings = setUserSettings;
exports.getUserSettings = getUserSettings;
exports.privateSettingErrorHandled = privateSettingErrorHandled;

var _httpService = require('../../helpers/httpService');

var HTTP = _interopRequireWildcard(_httpService);

var _config = require('../../config');

var _logging = require('../lib/app/logging');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------


var configuration = void 0;
var config = function config() {
    return !configuration ? _config.Configuration.getConfig() : configuration;
};
var baseUrl = function baseUrl() {
    return config().service.baseUrl;
};

// -------------------------------------------------------------- LOGGING --------------------------------------------------------------


var logger = void 0;
function loggingHelper(msg, attributes) {
    if (!logger) {
        logger = (0, _logging.appLogger)().create('user-setting');
    }
    logger.error(msg, attributes);
}

// Action Strings
var USER_SETTING_SET_START = exports.USER_SETTING_SET_START = 'USER_SETTING_SET_START';
var USER_SETTING_SET_COMPLETE = exports.USER_SETTING_SET_COMPLETE = 'USER_SETTING_SET_COMPLETE';
var USER_SETTING_SET_FAILURE = exports.USER_SETTING_SET_FAILURE = 'USER_SETTING_SET_FAILURE';

var USER_SETTING_GET_START = exports.USER_SETTING_GET_START = 'USER_SETTING_GET_START';
var USER_SETTING_GET_COMPLETE = exports.USER_SETTING_GET_COMPLETE = 'USER_SETTING_GET_COMPLETE';
var USER_SETTING_GET_FAILURE = exports.USER_SETTING_GET_FAILURE = 'USER_SETTING_GET_FAILURE';

var PRIVATE_SETTING_ERROR_HANDLED = exports.PRIVATE_SETTING_ERROR_HANDLED = 'PRIVATE_SETTING_ERROR_HANDLED';

function getheader(state) {
    var header = { 'Content-Type': 'application/json' };

    if (state && state.auth && state.auth.authInfo && state.auth.authInfo.access_token) {
        header.Authorization = 'Bearer ' + state.auth.authInfo.access_token;
    }

    return header;
}

function setUserSettings(setting) {
    return function (dispatch, getState) {
        dispatch({ type: USER_SETTING_SET_START });

        var reqUrl = baseUrl() + '/users';
        var state = getState();
        var header = getheader(state);

        // First check if they have accepted the TOS
        return HTTP.putData(reqUrl, header, setting).then(function () {
            dispatch({ type: USER_SETTING_SET_COMPLETE, setting: setting });
            return setting;
        }).catch(function (error) {
            if (error.status === '401') {
                // authentication failed
                loggingHelper('User setting authentication failed', { method: 'setUserSettings', callType: 'PUT', error: error });
            } else if (error.status === '404') {
                // user doesn't exist
                loggingHelper('User setting user doesnt exist', { method: 'setUserSettings', callType: 'PUT', error: error });
            } else {
                loggingHelper('User setting error', { method: 'setUserSettings', callType: 'PUT', error: error });
            }

            dispatch({ type: USER_SETTING_SET_FAILURE, error: error, dataCall: 'setUserSetting' });
            throw error;
        });
    };
}

function getUserSettings() {
    return function (dispatch, getState) {
        dispatch({ type: USER_SETTING_GET_START });

        var reqUrl = baseUrl() + '/users';
        var state = getState();
        var header = getheader(state);

        return HTTP.getData(reqUrl, header).then(function (response) {
            dispatch({ type: USER_SETTING_GET_COMPLETE, setting: response });
        }).catch(function (error) {
            if (error.status === '401') {
                // authentication failed
                loggingHelper('User setting authentication failed', { method: 'getUserSettings', callType: 'GET', error: error });
            } else if (error.status === '404') {
                // user doesn't exist
                loggingHelper('User setting user doesnt exist', { method: 'getUserSettings', callType: 'GET', error: error });
            } else {
                loggingHelper('User setting error', { method: 'getUserSettings', callType: 'GET', error: error });
            }

            dispatch({ type: USER_SETTING_GET_FAILURE, error: error });
        });
    };
}

function privateSettingErrorHandled() {
    return function (dispatch) {
        dispatch({ type: PRIVATE_SETTING_ERROR_HANDLED });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/user-setting.js
// module id = 774
// module chunks = 0